let goodsData = [
    {
	"id": 1000271,
	"name": "远程4G按键电子钥匙BT-01规格书.pdf",
    }, 
    {
	"id": 1000272,
	"name": "远程4G指纹电子钥匙FG-01规格书.pdf",
    }, 
    {
	"id": 1000273,
	"name": "远程4G屏幕电子钥匙SC-01规格书.pdf",
    }, 
    {
	"id": 1000274,
	"name": "无源锁管理平台规格书v1.3.pdf",
    }, 
]

export default goodsData


// WEBPACK FOOTER //
// ./src/lib/downloadData.js